import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toggle } from 'palette/Toggle';
import ActivateDeals from '@common/ActivateDeals/components/ActivateDeals';
import { FiltersList } from '@common/Filters/components/FiltersList';
import {
    ActiveFilters, FiltersListSeoBlock, FiltersPanel
} from '@common/Filters/containers';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { setModelImageMode } from '@common/Listing/actions/listingActions';
import ListingContext from '@common/Listing/ListingContext';
import { SPONSORED_PRODUCT_MODAL_ID } from '@common/Product/Sponsor/constants/modalIds';
import { SponsoredProductsModal } from '@common/Product/Sponsor/SponsoredProductsModal';
import { SubCategories } from '@common/SubCategories/containers/SubCategories';
import { isFeatureActive } from '@helpers/index';
import { ListingTopInfo } from './ListingTopInfo';
import ProductsCountInfo from './ProductsCountInfo';
import '../styles/ListingTop.scss';

export default function ListingTopSticky({
    navigation,
    categoryMenu,
    categoryName,
    filters,
    pageLimit,
    paging,
    hasOrderFilter,
    isAlt2Listing
}) {
    const dispatch = useDispatch();
    const config = useConfig();
    const translate = useTranslation();
    const { theme, isPremium } = useContext(ListingContext);
    const modelImageMode = useSelector(({ listing }) => listing.modelImageMode);

    const listingTopInfo = (
        <ListingTopInfo
            categoryName={categoryName}
            isAlt2Listing={isAlt2Listing}
            isPremium={isPremium}
            pageLimit={pageLimit}
            pagination={paging}
            theme={theme}
        />
    );

    const onToggleChange = () => {
        dispatch(setModelImageMode(!modelImageMode));
    };

    return (
        <>
            <div className="listing-top__row">
                <ActivateDeals />
            </div>
            <div className="listing-top listing-top--sticky">
                <div className="listing-top__row">
                    <FiltersList
                        filters={filters}
                        hasOrderFilter={hasOrderFilter}
                        theme={theme}
                    />
                    {isPremium && listingTopInfo}
                </div>
                <div className="listing-top__row listing-top__row--align-items-end">
                    {!isPremium && categoryMenu && categoryMenu.children.length > 0
                        && (
                            <SubCategories
                                customClass={theme === 'mod1' ? 'listing-top__subcategories' : ''}
                                subcategories={categoryMenu}
                            />
                        )}
                    {!isPremium && <FiltersPanel />}
                    <FiltersListSeoBlock
                        filters={filters}
                        navigation={navigation}
                    />
                </div>
            </div>
            <div className="listing-top__row listing-top__row--align-items-end">
                <ActiveFilters />
            </div>
            <div className="listing-top__row listing-top__row--align-items-end listing-top__row--mobile-hidden">
                <div className="listing-top__column listing-top__product-info-container">
                    <ProductsCountInfo categoryName={categoryName} />
                    {isFeatureActive('PLT-36479-sponsored-products', config) && (
                        <SponsoredProductsModal
                            className="listing-top__sponsored-icon"
                            id={SPONSORED_PRODUCT_MODAL_ID.listingTop}
                            linkLabel={translate('listing_products.tooltip_link')}
                            linkURL={translate('listing_products.tooltip_url')}
                            message={translate('listing_products.tooltip_text')}
                            title={translate('listing_products.tooltip_title')}
                        />
                    )}
                </div>
                <div className="listing-top__column">
                    {!isPremium && listingTopInfo}
                </div>
            </div>
            {isFeatureActive('PLT-50092_toggle_switch_product_model_images', config) && (
                <div className="listing-top__switch-toggle">
                    <div className="listing-top__switch-toggle-inner-box">
                        <Toggle
                            id="Model images"
                            isChecked={modelImageMode}
                            label={translate('listing.all.modelImages')}
                            value={modelImageMode}
                            variant="switch"
                            onChange={onToggleChange}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
